export default "<app-empyrean-loader width=\"500\" color=\"#EEF1F688\" speed=\"slow\" plain=\"true\"></app-empyrean-loader>\r\n"